/* eslint-disable complexity */
interface StoreHours {
	weekdaysOpen: string;
	weekdaysClose: string;
	sundayOpen: string;
	sundayClose: string;
}

export const parseStoreHours = (hoursText: string): StoreHours => {
	const weekdaysRegex = /Lun\. a Sab\. (\d{2}:\d{2}) a (\d{2}:\d{2}) hrs/;
	const sundayRegex = /Dom\. (\d{2}:\d{2}) a (\d{2}:\d{2}) hrs/;

	const weekdaysMatch = hoursText.match(weekdaysRegex);
	const sundayMatch = hoursText.match(sundayRegex);

	if (!weekdaysMatch || !sundayMatch) {
		throw new Error('Invalid hours format');
	}

	const [_, weekdaysOpen, weekdaysClose] = weekdaysMatch;
	const [__, sundayOpen, sundayClose] = sundayMatch;

	return {
		weekdaysOpen,
		weekdaysClose,
		sundayOpen,
		sundayClose,
	};
};

export const isStoreOpen = (storeHours: StoreHours): string => {
	const now = new Date();
	const currentHour = now.getHours();
	const currentMinute = now.getMinutes();

	const [weekdaysOpenHour, weekdaysOpenMinute] = storeHours.weekdaysOpen.split(':').map(Number);
	const [weekdaysCloseHour, weekdaysCloseMinute] = storeHours.weekdaysClose.split(':').map(Number);
	const [sundayOpenHour, sundayOpenMinute] = storeHours.sundayOpen.split(':').map(Number);
	const [sundayCloseHour, sundayCloseMinute] = storeHours.sundayClose.split(':').map(Number);

	const isWeekday = now.getDay() >= 1 && now.getDay() <= 6;
	const isSunday = now.getDay() === 0;

	if (isWeekday) {
		if (
			(currentHour > weekdaysOpenHour ||
				(currentHour === weekdaysOpenHour && currentMinute >= weekdaysOpenMinute)) &&
			(currentHour < weekdaysCloseHour ||
				(currentHour === weekdaysCloseHour && currentMinute <= weekdaysCloseMinute))
		) {
			return 'Abierto';
		} else {
			return `Cerrado - Abre a las${storeHours.weekdaysOpen}`;
		}
	}

	if (isSunday) {
		if (
			(currentHour > sundayOpenHour ||
				(currentHour === sundayOpenHour && currentMinute >= sundayOpenMinute)) &&
			(currentHour < sundayCloseHour ||
				(currentHour === sundayCloseHour && currentMinute <= sundayCloseMinute))
		) {
			return 'Abierto';
		} else {
			return `Cerrado - Abre a las${storeHours.sundayOpen}`;
		}
	}

	return 'Cerrado';
};
